/***************************************************************************************
* FileName      : SignupStats.js
* Description   : 해와관리자 > 가입통계 > 월별, 일별, 시간대별 
* Company       : (주)엘리그
* Author        : 박권희
* Created Date  : 2023.00.00
* Modifide Date : 
* Reference     : 
***************************************************************************************/
import {Row, Col, Button , Navbar, Nav, Container} from 'react-bootstrap';
import Day from "./SignupStats/Day";
import Month from "./SignupStats/Month";
import Time from "./SignupStats/Time";
import React, { useState } from 'react';

function SignupStats()
{
    const [activeComponent, setActiveComponent] = useState("Month");

    const handleButtonClick = (componentName) => {
      setActiveComponent(componentName);
    };

    return(
        <>
        <div className='mainContents'>
            {/*  가입통계  */}
            <div className='page-tit'>
                <h2>가입통계</h2>
            </div>
            <div className='setting-tab-buttons'> 
            
                <button className={activeComponent === "Month" ? "active-button" : "m-sm-btn w130"}
                        onClick={() => handleButtonClick("Month")}>월별</button>

                <button className={activeComponent === "Day" ? "active-button" : "m-sm-btn w130"}
                        onClick={() => handleButtonClick("Day")}>일별</button>
          
                <button className={activeComponent === "Time" ? "active-button" : "m-sm-btn w130"}
                        onClick={() => handleButtonClick("Time")}>시간대별</button>
          
           
            </div>
            {/* 월별 */}
            {activeComponent === "Month" && <Month />}
            
            {/* 일별 */}
            {activeComponent === "Day" && <Day />}

            {/* 시간대별 */}
            {activeComponent === "Time" && <Time />}


        </div>

        </>
    )
}

export default SignupStats